// frontend/src/pages/BlockchainDashboardPage.jsx
import React from "react";
import BlockchainDashboard from "../components/BlockchainDashboard";

export default function BlockchainDashboardPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900/20 to-gray-900">
      <BlockchainDashboard />
    </div>
  );
}
